import { initialStateByModule } from './state'

const state = initialStateByModule('plan')

const CHANGE_VALUE_INSTALLMENTS = 'changeValueInstallments'
const CHANGE_PLAN_PARCEL = 'changePlanParcel'
const CHANGE_PLAN_PROMO_CODE_CODE = 'changePlanPromoCodeCode'
const CHANGE_PLAN_PROMO_CODE_APPLIED = 'changePlanPromoCodeApplied'
const CHANGE_PLAN_TOTAL_PRICE = 'setPlanTotalPrice'
const CHANGE_PLAN_PROMO_COMPLETE_PRICE = 'setPlanPromoCompletePrice'

const mutations = {
  [CHANGE_VALUE_INSTALLMENTS] (state, payload) {
    state.parcelasPrecos = payload
  },
  [CHANGE_PLAN_PARCEL] (state, payload) {
    state.parcela = payload
  },
  [CHANGE_PLAN_PROMO_CODE_CODE] (state, payload) {
    state.promoCode.code = payload
  },
  [CHANGE_PLAN_PROMO_CODE_APPLIED] (state, payload) {
    state.promoCode.applied = payload
  },
  [CHANGE_PLAN_TOTAL_PRICE] (state, payload) {
    state.precoTotal = payload
  },
  [CHANGE_PLAN_PROMO_COMPLETE_PRICE] (state, payload) {
    state.promo.completePrice = payload
  }
}

const actions = {
  [CHANGE_PLAN_PARCEL]: ({ commit }, payload) => commit(CHANGE_PLAN_PARCEL, payload),
  [CHANGE_PLAN_PROMO_CODE_CODE]: ({ state, commit, dispatch }, payload) => {
    commit(CHANGE_PLAN_PROMO_CODE_CODE, payload.code)
    commit(CHANGE_PLAN_PROMO_CODE_APPLIED, false)
    commit(CHANGE_PLAN_PROMO_COMPLETE_PRICE, state.default.completePrice)
    commit(CHANGE_PLAN_TOTAL_PRICE, state.default.completePrice)

    const data = {
      valid: null,
      activated: false
    }

    dispatch('promoCode/changePromoCodeActivated', data, { root: true })

    if (payload.search || !payload.code) {
      dispatch('promoCode/changePromoCodeCommission', null, { root: true })
    }
  },
  [CHANGE_PLAN_PROMO_CODE_APPLIED] ({ state, commit }, payload) {
    commit(CHANGE_PLAN_PROMO_CODE_APPLIED, payload.applied)
    commit(CHANGE_PLAN_PROMO_COMPLETE_PRICE, payload.completePrice)
    commit(CHANGE_PLAN_TOTAL_PRICE, state.promo.completePrice)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
